import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";

import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

// import FeedbackIcon from "@mui/icons-material/Feedback";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: 0,
  },
  headerPaper: {
    height: 90,
    width: 90,
    backgroundColor: "#1c355e",
    zIndex: 9,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    width: 260,
    marginTop: -50,
    borderRadius: 0,
  },
  cardHeader: {
    fontSize: 20,
    marginTop: 55,
    fontWeight: 600,
  },
  headerImage: {
    width: 70,
    height: 70,
    color: "#fff",
    marginTop: 10,
    marginLeft: 10,
  },
  divideMe: {
    marginTop: 10,
    marginBottom: 10,
  },
}));

export const ConfirmationDialog = (props) => {
  const classes = useStyles();
  const {
    title,
    children,
    showHelp,
    alert,
    confirmBtnLabel,
    cancelBtnLabel,
    open,
    setOpen,
    onConfirm,
    onCancel,
  } = props;
  const { t } = useTranslation();

  ConfirmationDialog.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.string,
    showHelp: PropTypes.bool,
    alert: PropTypes.string,
    confirmBtnLabel: PropTypes.string,
    cancelBtnLabel: PropTypes.string,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
  };
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="confirmation-dialog"
      classes={{ paper: classes.dialogPaper }}
    >
      <Grid container direction="column" className={classes.pageHolder}>
        {/* <Grid item>
          <Grid
            container
            style={{ width: 300, backgroundColor: "currentColor" }}
          >
            <Grid
              item
              className={classes.headerPaper}
              style={{ marginLeft: 105 }}
            >
              <FeedbackIcon className={classes.headerImage} />
            </Grid>
          </Grid>
        </Grid> */}
        <Grid item>
          <Grid container direction="column">
            <Grid item>
              <Paper className={classes.paper} elevation={0}>
                <Grid container direction="column">
                  <Grid item>
                    <Typography className={classes.cardHeader}>
                      {title}
                    </Typography>
                  </Grid>
                  <Divider className={classes.divideMe} />
                  <Grid item>
                    {children === undefined
                      ? ""
                      : children.split("\n").map((i, key) => {
                          return (
                            <div key={key} style={{ minHeight: 20 }}>
                              {i.length > 0 ? i : "\u00A0"}
                            </div>
                          );
                        })}
                  </Grid>
                  <Grid item>
                    {alert === undefined
                      ? ""
                      : alert.split("\n").map((i, key) => {
                          return (
                            <div
                              key={key}
                              style={{
                                minHeight: 20,
                                color: "#d1495b",
                                fontStyle: "italic",
                              }}
                            >
                              {i.length > 0 ? i : "\u00A0"}
                            </div>
                          );
                        })}
                  </Grid>
                  {showHelp !== true ? (
                    ""
                  ) : (
                    <Grid item>
                      {t("documents.showHelpText")}
                      <RouterLink to="help">
                        {t("documents.showHelpLinkText")}
                      </RouterLink>
                    </Grid>
                  )}
                  <Grid container direction="row" style={{ marginTop: 20 }}>
                    {cancelBtnLabel === "Hidden" ? (
                      <Grid item xs={12}>
                        <Button
                          size="medium"
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            setOpen(false);
                            onConfirm();
                          }}
                        >
                          {confirmBtnLabel === undefined
                            ? "Yes"
                            : confirmBtnLabel}
                        </Button>
                      </Grid>
                    ) : (
                      <>
                        <Grid item xs={6} style={{ paddingLeft: 30 }}>
                          <Button
                            size="medium"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                              setOpen(false);
                              onConfirm();
                            }}
                          >
                            {confirmBtnLabel === undefined
                              ? t("home.yesButton")
                              : confirmBtnLabel}
                          </Button>
                        </Grid>
                        <Grid item xs={6} style={{ paddingRight: 30 }}>
                          <Button
                            size="medium"
                            variant="contained"
                            color="secondary"
                            onClick={() => {
                              setOpen(false);
                              {
                                onCancel !== undefined ? onCancel() : "";
                              }
                            }}
                          >
                            {cancelBtnLabel === undefined
                              ? "No"
                              : cancelBtnLabel}
                          </Button>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};
